import { Th } from "@chakra-ui/react";

export function ThActions() {
  return <Th aria-label="Actions" w="36px" />;
}
